<template>
    <div v-if="dialogList.isTrue" :style="{ width: dialogList.width }">
        <div class="dialog-box" v-if="dialogList.type === 'A'">
            <p class="remove" @click="remove" v-if="dialogList.remove">×</p>
            <p class="remove" @click="remove" v-if="!dialogList.save">×</p>
            <p class="mt-30 mb-20 bold fs-19" style="text-align: center">
                {{ dialogList.title }}
            </p>
            <p
                style="text-align: center"
                class="label-color"
                v-if="!dialogList.remove"
            >
                完善信息成为普通会员，便于我们为您提供更好的服务
            </p>
            <div class="box1 mt-30">
                <div class="box-name">
                    <span style="color: red">*</span>您是
                </div>
                <div
                    v-for="(item, ind) in identity"
                    :key="ind"
                    class="box-title boxTitle"
                    @click="toIdentity(ind)"
                    :class="item.isTrue === true ? 'active' : ''"
                >
                    {{ item.label }}
                </div>
            </div>
            <div class="box1">
                <div class="box-name">
                    <span style="color: red">*</span>考试类型
                </div>
                <div
                    v-for="(item, ind) in examination"
                    :key="ind"
                    class="box-title boxTitle"
                    @click="toExamination(ind)"
                    :class="item.isTrue === true ? 'active' : ''"
                >
                    {{ item.label }}
                </div>
            </div>
            <div class="box1">
                <div class="box-name">
                    <span style="color: red">*</span>考生类型
                </div>
                <div
                    v-for="(item, ind) in examinee"
                    :key="ind"
                    class="box-title boxTitle"
                    @click="toExaminee(ind)"
                    :class="item.isTrue === true ? 'active' : ''"
                >
                    {{ item.label }}
                </div>
            </div>
            <div class="box1">
                <div class="box-name">
                    <span style="color: red">*</span>高中年份
                </div>
                <div
                    v-for="(item, ind) in year"
                    :key="ind"
                    class="box-title boxTitle"
                    @click="toYear(ind)"
                    :class="item.isTrue === true ? 'active' : ''"
                >
                    {{ item.label }}
                </div>
            </div>
            <div class="box1">
                <div class="box-name">
                    <span style="color: red">*</span>就读学校
                </div>
                <el-cascader
                    :options="school"
                    @change="handleChange"
                    v-model="province"
                    :disabled="dialogList.disabled || dialogList.disabledEdit"
                    placeholder="请选择城市"
                />&emsp;
                <el-autocomplete
                    v-model="search"
                    :fetch-suggestions="querySearch"
                    placeholder="输入关键字搜索内容"
                    suffix-icon="el-icon-search"
                    @select="handleSelect"
                    :disabled="dialogList.disabled"
                >
                    <template slot-scope="{ item }">
                        <div>{{ item.school }}</div>
                    </template>
                </el-autocomplete>
            </div>
            <div class="button fr-jc" v-if="dialogList.save">
                <div class="save" @click="userSave">保存</div>
            </div>
            <div class="button fr-jsa" v-else-if="dialogList.remove">
                <div class="save saveActive" @click="remove">关闭</div>
                <div class="save" @click="edit">修改</div>
            </div>
            <div class="button fr-jsa" v-else>
                <div class="save saveActive" @click="cancel">取消</div>
                <div class="save" @click="userSave">保存</div>
            </div>
        </div>
        <div class="dialog-box" v-if="dialogList.type === 'B'">
            <p class="remove" @click="remove">×</p>
            <p class="mt-30 mb-50 bold fs-19" style="text-align: center">
                业务省份
            </p>
            <div class="mb-30 dialog-province">
                <div
                    v-for="(item, ind) in opennesSf"
                    :key="ind"
                    class="province-title fr-ac-jc"
                    :class="item.isTrue ? 'active' : ''"
                    @click="openProvince(ind)"
                >
                    <span class="mr-10">{{ item.py }}</span
                    >{{ item.province }}
                </div>
                <div class="province-title" style="border: none"></div>
            </div>
            <!-- <p style="text-align: center" class="label-color">
        其他省份即将开放，敬请期待！
      </p> -->
            <div class="button fr-jsa">
                <div class="save saveActive" @click="remove">取消</div>
                <div class="save" @click="save">确定</div>
            </div>
        </div>
        <div class="dialog-box" v-if="dialogList.type === 'C'">
            <div class="fr-ac-jsb" style="padding: 0 20px" @click="save">
                <p class="fs-16">温馨提示</p>
                <p class="fs-24" @click="remove" v-if="dialogList.showClose">×</p>
            </div>
            <div
                style="padding: 5% 0 10% 0; text-align: center; font-size: 16px"
            >
                {{ dialogList.title }}
            </div>
            <div class="buttonOpen fs-16" @click="saveButton">
                {{ dialogList.button }}
            </div>
        </div>
    </div>
</template>
<style lang="scss">
.dialog-box {
    background: #fff;
    position: relative;
    padding: 20px 0;
    .remove {
        font-size: 30px;
        position: absolute;
        right: 20px;
        top: 10px;
        cursor: pointer;
    }
    .dialog-province {
        width: 100%;
        padding: 0 15%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 30px;
        .province-title {
            width: 140px;
            padding: 9px 0;
            border: 1px solid #ccc;
            border-radius: 5px;
            margin-bottom: 10px;
        }
        .active {
            background: #1676ff;
            color: #fff;
        }
    }
    .buttonOpen {
        width: 80px;
        height: 36px;
        background: #1676ff;
        margin: 0 auto;
        border-radius: 5px;
        color: #fff;
        text-align: center;
        line-height: 36px;
    }
}
.box1 {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-left: 10%;
    font-weight: 100;
    .box-name {
        width: 75px;
        font-weight: bold;
        font-size: 15px;
    }
    .boxTitle {
        width: 90px;
        height: 40px;
        border: 1px solid #d1d0d0;
        margin-right: 15px;
        line-height: 40px;
        text-align: center;
        border-radius: 5px;
        font-size: 15px;
    }
    .active {
        background: #1676ff;
        color: #fff;
    }
}
.button {
    margin: 60px 0 40px 0;
    padding: 0 20%;
    .save {
        width: 30%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 5px;
        background: #1676ff;
        color: #fff;
    }
    .saveActive {
        background: #fff;
        color: #1676ff;
        border: 1px solid #1676ff;
    }
}
</style>
<script>
export default {
    name: "DialogView",
    props: {
        dialogList: Object,
    },
    watch: {
        dialogList: {
            immediate: true,
            handler(newVal, oldVal) {
                this.getIdentity(this.identity, newVal.crowd);
                this.getIdentity(this.examination, newVal.candidates_identity);
                this.getIdentity(this.examinee, newVal.school_type);
                this.getIdentity(this.year, newVal.graduation);
                this.search = newVal.middle_school;
                this.province = [
                    this.dialogList.school_province,
                    this.dialogList.school_city,
                ];
            },
        },
    },
    data() {
        return {
            identity: [
                {
                    label: "学生",
                    isTrue: false,
                },
                {
                    label: "家长",
                    isTrue: false,
                },
            ], //身份
            examination: [
                {
                    label: "春季高考",
                    isTrue: false,
                },
                {
                    label: "夏季高考",
                    isTrue: false,
                },
                {
                    label: "其他",
                    isTrue: false,
                },
            ], //考试
            examinee: [
                {
                    label: "高中",
                    isTrue: false,
                },
                {
                    label: "中职",
                    isTrue: false,
                },
                {
                    label: "其他",
                    isTrue: false,
                },
            ], //考生
            year: [
                {
                    label: "2024",
                    isTrue: false,
                },
                {
                    label: "2025",
                    isTrue: false,
                },
                {
                    label: "2026",
                    isTrue: false,
                },
            ], //年份
            school: [], //省份列表
            province: "", //省份
            search: "",
            opennesSf: [], //学校列表
            schoolList: [], //原省份列表
            searchList: "",
        };
    },
    methods: {
        //省市区列表
        async getProvinceList() {
            const res = await this.$http.fetch(
                "/api/basedata/getProvinCity",
                {}
            );
            if (res.status === 200) {
                this.schoolList = res.data;
                this.school = JSON.parse(JSON.stringify(res.data));
                this.school.forEach((item) => {
                    item.value = item.label;
                    item.children.forEach((child) => {
                        child.value = child.label;
                    });
                });
            }
        },
        //选择的省市区
        handleChange(label) {
            this.province = label;
        },
        async querySearch(queryString, cb) {
            const res = await this.$http.fetch("/api/middleschool/lists", {
                province: this.province[0],
                city: this.province[1],
                school_type: this.getisTrue(this.examinee),
                school: this.search,
            });
            if (res.status === 200) {
                let results = res.data;
                this.searchList = res.data;
                cb(results);
            } else {
                this.$message.error(res.msg);
            }
        },
        toIdentity(ind) {
            if (!this.dialogList.disabled) {
                this.identity.forEach((item, index) => {
                    if (index === ind) {
                        item.isTrue = true;
                    } else {
                        item.isTrue = false;
                    }
                });
            }
        },
        toExamination(ind) {
            if (!this.dialogList.disabled) {
                this.examination.forEach((item, index) => {
                    if (index === ind) {
                        item.isTrue = true;
                    } else {
                        item.isTrue = false;
                    }
                });
            }
        },
        toExaminee(ind) {
            if (!this.dialogList.disabled) {
                this.examinee.forEach((item, index) => {
                    if (index === ind) {
                        item.isTrue = true;
                    } else {
                        item.isTrue = false;
                    }
                });
            }
        },
        toYear(ind) {
            if (!this.dialogList.disabled) {
                this.year.forEach((item, index) => {
                    if (index === ind) {
                        item.isTrue = true;
                    } else {
                        item.isTrue = false;
                    }
                });
            }
        },
        handleSelect(value) {
            this.search = value.school;
        },
        async getProvince() {
            const res = await this.$http.fetch(
                "api/basedata/getBusinessProvince",
                {}
            );
            if (res.status === 200) {
                let arr = res.data;
                arr.forEach((item) => {
                    item.isTrue = false;
                });
                this.opennesSf = arr;
                this.opennesSf.forEach((item) => {
                    if (item.province === this.dialogList.province) {
                        item.isTrue = true;
                    }
                });
            }
        },
        remove() {
            this.$emit("remove");
        },
        saveButton() {
            this.$emit("remove");
            if (this.dialogList.type === "C") {
                if (this.dialogList.province === "浙江") {
                    this.$message.error("请去小程序购买，购买后刷新页面");
                } else if (this.dialogList.button === "开通") {
                    this.$router.push("/pay/pay_index");
                }
            }
        },
        openProvince(ind) {
            this.opennesSf.forEach((item, index) => {
                if (index === ind) {
                    item.isTrue = true;
                } else {
                    item.isTrue = false;
                }
            });
        },
        save() {
            this.$emit("save", this.getisTrue(this.opennesSf));
        },
        //获取isTrue为true的方法
        getisTrue(array) {
            let arr = array.filter((item) => {
                return item.isTrue === true;
            });
            return arr.map((item) => item.label || item.province).join(",");
        },
        userSave() {
            let form_data = {
                crowd:
                    this.getisTrue(this.identity) === "学生"
                        ? 1
                        : this.getisTrue(this.identity) === "家长"
                        ? 2
                        : "",
                candidates_identity: this.getisTrue(this.examination),
                school_type: this.getisTrue(this.examinee),
                graduation: this.getisTrue(this.year),
                middle_school_id: "",
                province_id: "",
                city_id: "",
                region_id: "",
            };
            this.schoolList.forEach((item) => {
                if (this.province[0] === item.label) {
                    item.children.forEach((child) => {
                        if (this.province[1] === child.label) {
                            form_data.province_id = child.province_id;
                            form_data.city_id = child.value;
                        }
                    });
                }
            });
            if (this.search !== "") {
                this.searchList.forEach((item) => {
                    if (this.search === item.school) {
                        form_data.middle_school_id = item.id;
                        form_data.region_id = item.region_id;
                    }
                });
            }
            this.$emit("userSeve", form_data);
        },
        getIdentity(array, str) {
            array.filter((item) => {
                if (item.label === str) {
                    return (item.isTrue = true);
                }
            });
            return array;
        },
        edit() {
            this.$emit("userEdit");
            this.identity.forEach((item) => (item.isTrue = false));
            this.examination.forEach((item) => (item.isTrue = false));
            this.examinee.forEach((item) => (item.isTrue = false));
            this.year.forEach((item) => (item.isTrue = false));
            // this.province = [];
            this.search = "";
        },
        cancel() {
            this.$emit("userCancel");
            this.$emit("getEdit", this.dialogList);
            this.getIdentity(this.identity, this.dialogList.crowd);
            this.getIdentity(
                this.examination,
                this.dialogList.candidates_identity
            );
            this.getIdentity(this.examinee, this.dialogList.school_type);
            this.getIdentity(this.year, this.dialogList.graduation);
            this.province = [
                this.dialogList.school_province,
                this.dialogList.school_city,
            ];
            this.search = this.dialogList.middle_school;
        },
    },
    mounted() {
        this.getProvinceList();
        this.getProvince();
        // this.getIdentity(this.identity, this.dialogList.crowd);
        // this.getIdentity(this.examination, this.dialogList.candidates_identity);
        // this.getIdentity(this.examinee, this.dialogList.school_type);
        // this.getIdentity(this.year, this.dialogList.graduation);
    },
    created() {},
};
</script>
